import { render } from "./LensList.vue?vue&type=template&id=c81a8e70&ts=true"
import script from "./LensList.vue?vue&type=script&lang=ts"
export * from "./LensList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__